// ! Avoid this function unless aboslutely necessary.

// ? should look for ways to fix source data (or its type).
export function makeNonEmptyArray<T>(
  array: (T | undefined | null)[] | undefined | null
): T[] {
  if (array == null) {
    return []
  }

  return array.reduce((acc, item) => {
    if (item == null) {
      return acc
    }

    return [...acc, item]
  }, [] as T[])
}
